var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import store from "../../store";
import VueDialog from "../../interface/IVueDialog";
import { Component } from 'vue-property-decorator';
import ServiceService from '../../api/ServiceService';
import { Loading } from 'element-ui';
import GlobalVue from "../../globalVue";
var PayDialog = (function (_super) {
    __extends(PayDialog, _super);
    function PayDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fix_fee_type = null;
        _this.payType = 2;
        _this.isQrShow = false;
        _this.isPayFlag = false;
        _this.minute = 15;
        _this.second = '00';
        _this.timer = null;
        _this.isOpenOperate = false;
        _this.paymentInfo = {};
        _this.fix_fee_types = [];
        _this.service_id = 0;
        _this.payment_mode = null;
        _this.account_period = '';
        _this.service_name = '';
        _this.qrcode_path = '';
        _this.order_money = '';
        return _this;
    }
    Object.defineProperty(PayDialog.prototype, "params", {
        get: function () {
            return {
                payment_type: this.payType,
                service_id: this.service_id,
                payment_mode: this.paymentInfo.payment_mode,
                fix_fee_type: this.fix_fee_type
            };
        },
        enumerable: true,
        configurable: true
    });
    PayDialog.prototype.created = function () {
        this.service = ServiceService.getInstance();
    };
    PayDialog.prototype.mounted = function () {
        this.isOpenOperate = this.isOpenOperate || false;
        this.paymentInfo = this.paymentInfo;
        this.fix_fee_types = this.paymentInfo.fix_fee_types || [];
        this.service_id = this.service_id;
        this.service_name = this.service_name;
        this.payment_mode = this.payment_mode;
        this.paymentInfo.money = '';
        if (this.paymentInfo.payment_mode == 1 || this.payment_mode == 1) {
            this.payService();
        }
        var that = this;
        GlobalVue.$on('closeDialog', function () {
            that.close();
        });
    };
    PayDialog.prototype.changeFixFeeType = function (fix_fee_type) {
        var _this = this;
        if (this.fix_fee_type == fix_fee_type)
            return;
        this.fix_fee_type = fix_fee_type;
        this.fix_fee_types.map(function (item) {
            if (item.fix_fee_type == fix_fee_type) {
                _this.paymentInfo.money = item.money.replace(/[^\d.]/ig, "");
            }
        });
        this.payService();
    };
    PayDialog.prototype.changePaymentType = function (index) {
        if (this.payType == index)
            return;
        clearInterval(this.timer);
        this.payType = index;
        this.isQrShow = false;
        if (index == 1)
            return;
        this.payService();
    };
    PayDialog.prototype.payService = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service[this.isOpenOperate ? 'payOpenService' : 'payRenewService'](this.params).then(function (res) {
            loadingInstance.close();
            _this.account_period = res.data.data.s_time + " ~ " + res.data.data.e_time;
            _this.order_money = res.data.data.order_money;
            if (_this.payType) {
                _this.qrcode_path = res.data.data.qrcode_path;
                _this.isQrShow = true;
                if (_this.timer) {
                    clearInterval(_this.timer);
                }
                _this.timer = setInterval(function () {
                    _this.getPayFlag(res.data.data.order_id);
                }, 3000);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PayDialog.prototype.getPayFlag = function (order_id) {
        var _this = this;
        var params = { order_id: order_id };
        this.service.getPayFlag(params).then(function (res) {
            if (res.data.data.is_pay == 1) {
                _this.isQrShow = false;
                _this.isPayFlag = true;
                clearInterval(_this.timer);
                _this.$emit('paySuccess');
                _this.service.getServiceWarning().then(function (res) {
                    store.dispatch('updateServiceData', res.data.data);
                    store.dispatch('updateServiceFlag', res.data.data.flag == 2 || false);
                    _this.$closeDialog();
                }, function (error) {
                    _this.$message.error(error.message);
                });
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PayDialog.prototype.close = function () {
        clearInterval(this.timer);
        this.$closeDialog();
    };
    PayDialog.prototype.destroyed = function () {
        clearInterval(this.timer);
    };
    PayDialog = __decorate([
        Component({
            components: {}
        })
    ], PayDialog);
    return PayDialog;
}(VueDialog));
export default PayDialog;
